<script>
import { reminderMetaFields as metaFields } from "./metaFields";
import { Validator, } from "@/plugins/validator";
export default {
    name: "ReminderDetailsForm",

    data() {

        return {
            reminder: {
                id: 0,
                patientID: this.$route.params.patientID,
                visitNo: this.$route.params.visitNo,
                encounterID: this.$route.query.encounterID,
                date: window.moment().format(`YYYY-MM-DD`),
                time: window.moment().format('HH:MM'),
                userName: this.$root.username,
                cancelled: false,
            },
            errors: [],
            reminders: [],
        };
    },

    mounted() {

        this.fetchMFReminders();
    },

    methods: {

        fetchMFReminders() {
            let url = `MedicalFile/GetPatientReminders`;
                url += `?PatientID=${this.$route.params.patientID}`;
                url += `&VisitNo=${this.$route.params.visitNo}`;

            return this.$http.get(url).then(response => { this.reminders = response.data; })
                .catch(() => {});
        },

        saveData() {

            new Validator(this.reminder, metaFields).validate().then(() => {
                this.$root.loading = true;
                this.$http.post(`MedicalFile/PatientReminders`, this.reminder).then(() => {
                    this.reminder = {
                        id: 0,
                        patientID: this.$route.params.patientID,
                        visitNo: this.$route.params.visitNo,
                        encounterID: this.$route.query.encounterID,
                        date: window.moment().format(`YYYY-MM-DD`),
                        time: window.moment().format('HH:MM'),
                        userName: this.$root.username,
                        cancelled: false,
                    };
                    this.$root.loading = false;
                    this.fetchMFReminders();
                }).catch(() => { this.$root.loading = false; });
            }).catch(errors => { this.errors = errors; });
        },
    },
}
</script>
<template>
<div class="w-full flex flex-wrap">
    <div class="md:w-1/4 sm:w-full p-tiny">
        <label for="grid-remider-date" class="label-control">Date:</label>
        <input type="date" v-model.trim="reminder.date" 
            id="grid-remider-date" class="input-control input-sm text-xs">
        <p class="form-text-error" v-if="errors.filter(error => error.field == 'date').length">
            {{ errors.filter(error => error.field == 'date')[0].message }}</p>
    </div>
    <div class="md:w-1/5 sm:w-full p-tiny">
        <label for="grid-remider-time" class="label-control">Time:</label>
        <input type="time" 
            v-model.trim="reminder.time" id="grid-remider-time" class="input-control input-sm text-xs">
        <p class="form-text-error" v-if="errors.filter(error => error.field == 'time').length">
            {{ errors.filter(error => error.field == 'time')[0].message }}</p>
    </div>
    <div class="md:w-1/3 sm:w-full p-tiny">
        <label for="grid-comment" class="label-control">Comment:</label>
        <textarea v-model.trim="reminder.comment" 
            id="grid-comment" cols="30" rows="2" class="input-sm input-control text-xs"></textarea>
    </div>
    <div class="md:w-1/12 sm:w-full p-tiny text-right">
        <button 
            class="btn-sm btn-primary text-xs rounded mt-5" 
            @click.prevent="saveData"><i class="fa fa-save"></i> Save</button>
    </div>
    <div class="w-full overflow-auto">
        <table class="table">
            <thead class="bg-blue-500 text-sm text-white">
                <tr class="flex w-full">
                    <th class="p-tiny flex-1">Date</th>
                    <th class="p-tiny flex-1">Time</th>
                    <th class="p-tiny flex-1">Comment</th>
                    <th class="p-tiny flex-1">Action</th>
                </tr>
            </thead>
            <tbody 
                class="text-sm bg-gray-100 flex flex-col items-center overflow-auto">
                <tr v-for="(rem, idx) in reminders" class="flex w-full" :key="idx">
                    <td class="p-tiny flex-1">{{ rem.date | dateFormat }}</td>
                    <td class="p-tiny flex-1">{{ rem.time }}</td>
                    <td class="p-tiny flex-1">{{ rem.comment }}</td>
                    <td class="p-tiny flex-1">
                        <button class="btn-sm text-xs btn-primary" 
                            title="Edit" 
                            @click.prevent="reminder={ ...rem, date: $root.formatDate(rem.date),}">
                                <i class="fa fa-edit"></i></button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</template>